export default 'CONSUMER_SESSION';
